import { useParams } from "react-router-dom";
import ProfileBailleurShow from "../../components/Profile/ProfileBailleurShow";

export default function ProfileBailleurShowPage() {
  const { profileBailleurId } = useParams();
  return (
    <ProfileBailleurShow profileBailleurId={parseInt(profileBailleurId)} />
  );
}
